import { render, staticRenderFns } from "./NotDelivered.vue?vue&type=template&id=177c3e92&"
import script from "./NotDelivered.vue?vue&type=script&lang=js&"
export * from "./NotDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports